// De qué cadena(s) puede ver cobranza el usuario, según sus asignaciones de rol. Puro y sin React.
//
// `GET /retailers` exige scope TENANT: a un usuario LEVEL_1 (acotado a UNA cadena) le responde 403,
// así que su cadena se deriva del `scopeRef` del rol en vez de pedirle que elija de una lista vacía.
import type { RoleAssignmentInfoLocal } from '@/api/types/MeLocal';

export interface RetailerScope {
    /** La cadena a la que el usuario está acotado, o `null` si puede elegir entre varias. */
    fixedRetailerId: string | null;
    /** `true` cuando el usuario abarca todo el silo (TENANT/PLATFORM) y sí puede elegir. */
    canChoose: boolean;
}

export function resolveRetailerScope(
    assignments: readonly RoleAssignmentInfoLocal[],
): RetailerScope {
    const coversSilo = assignments.some(
        (assignment) => assignment.scope === 'TENANT' || assignment.scope === 'PLATFORM',
    );
    if (coversSilo) return { fixedRetailerId: null, canChoose: true };

    const retailerIds = [
        ...new Set(
            assignments
                .filter((assignment) => assignment.scope === 'LEVEL_1')
                .map((assignment) => assignment.scopeRef),
        ),
    ];

    // Con más de una cadena y sin permiso de listar no hay forma de mostrar sus nombres: se prefiere
    // que la pantalla lo diga a elegir una por el usuario en silencio.
    return { fixedRetailerId: retailerIds.length === 1 ? retailerIds[0] : null, canChoose: false };
}
